import React, { useEffect, useRef, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Home from "./components/home";
import Resume from "./components/Resume";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import Particles from "./components/Particles";

import "./App.css";

function App() {
    const shellRef = useRef(null);
    const [showIndicator, setShowIndicator] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const shell = shellRef.current;
        if (!shell) return;

        const onScroll = () => {
            const pageHeight = shell.clientHeight;
            const totalPages = Math.round(shell.scrollHeight / pageHeight);
            const currentPage = Math.round(shell.scrollTop / pageHeight) + 1;
            setCurrentPage(currentPage);
            setShowIndicator(currentPage < totalPages);
        };

        onScroll();
        shell.addEventListener("scroll", onScroll, { passive: true });
        return () => shell.removeEventListener("scroll", onScroll);
    }, []);

    const scrollToNext = () => {
        const shell = shellRef.current;
        if (!shell) return;
        const pageHeight = shell.clientHeight;
        const currentPage = Math.round(shell.scrollTop / pageHeight);
        shell.scrollTo({
            top: (currentPage + 1) * pageHeight,
            behavior: "smooth",
        });
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <Particles isHomeActive={currentPage === 1} />
            <div className="page-shell" ref={shellRef}>
                <section className="page">
                    <Home />
                </section>
                <section className="page">
                    <Resume />
                </section>
                <section className="page">
                    <Portfolio />
                </section>
                <section className="page">
                    <Contact />
                </section>
            </div>
            {showIndicator ? (
                <button
                    className="scroll-indicator"
                    aria-label="Scroll to next section"
                    type="button"
                    onClick={scrollToNext}
                >
                    <span className="scroll-indicator__arrow" />
                </button>
            ) : null}
        </React.Fragment>
    );
}

export default App;
